// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  reservationURL: 'https://apidev.thefeast.ai/reservations/api',
  ukiramaURL: 'https://eqa.easyeat.ai/thirdpartyservice/api/v1/ukirama',
  envName: 'local',
  phpURL: 'https://apidev.thefeast.ai',
  // baseURL: "http://localhost:80",
  google_apiKey: 'AIzaSyAijQUJwvaOO4bvkPZftRv5FhcAY7R1Hs8',
  paymentURL: 'https://apidev.thefeast.ai/payments',
  appURL: 'https://app-dev.easyeat.ai',
  nestURL: 'https://apidev.thefeast.ai/my',
  reportingURL: 'https://apidev.thefeast.ai/reporting',
  segment_sample_csv_base_url: 'https://eev-segment-name-output-prod.s3.ap-southeast-1.amazonaws.com',
  analyticsURL: 'https://apidev.thefeast.ai/reporting',
  cmmURL: 'https://apidev.thefeast.ai/cmm',
  syncURL: 'https://apidev.thefeast.ai/sync-service',
  rtcUrl: 'https://rtc-dev.thefeast.ai',
  secretKey: 'easyeat@A438',
  JITSU_KEY: 'js.mkjj9wf1fec050z8f2d1mk.8hfeskrgucq12kgdd78yk7',
  JITSU_URL: 'https://jitsu-dev.easyeat.ai/',
  SEGMENT_KEY: '5lcAu7CNpni3D50Vc2NIHHojc4j55NMG',
  aws_s3_bucket_url: 'https://d3pcazt4taz3aq.cloudfront.net',
  loyaltyURL: 'https://apidev.thefeast.ai/loyalty',
  razorPayScript: "https://sandbox.merchant.razer.com/MOLPay/API/seamless/3.16/js/MOLPay_seamless.deco.js",
  wsSocketPrintEndpoint: 'ws://127.0.0.1:7980/print',
  wsReconnectInterval: 10000,
  pusherConfig: {
    app_id: '1232637',
    key: '66c524b4962c022f2ac1',
    secret: 'a0ec152a25aac326d9f0',
    cluster: 'ap1',
  },

  MQTTCONFIG: {
    connectOnCreate: true,
    hostname: 'mqtt-dev.easyeat.ai',
    port: 2002,
    keepalive: 10,
    username: '',
    password: '',
    path: '/mqtt',
  },
  temp_pin: '1234',
  rockset: '',
  rockset_lambda_url: 'https://api.usw2a1.rockset.com/v1/orgs/self/ws/prod_ws/lambdas',
  rockset_api_key: 'W5KCx6XY6IoSLo9bdraNr7fnvgfn2xaaYcVQ8YYHZULaLanN9YCjF1ajTQbYkhWq',
  sentry: {
    dsn: 'https://6b6bfb0eb570d4cd012edbb6a9654fcd@o372957.ingest.us.sentry.io/4505831869382656',
    tracesSampleRate: 1
  },
  fmhAuthUrl: 'https://qa.foodmarkethub.com/processing-authorization',
  fmhDemoUrl: 'https://www.foodmarkethub.com/restaurants-get-free-demo',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
